import { TicketSampleFormType } from 'components/ticket-samples/TicketSampleForm';

export const createTicketSampleInitialValues: Partial<TicketSampleFormType> = {
  isActive: true
};
